import { render, staticRenderFns } from "./MyChild.vue?vue&type=template&id=5b58c94a&scoped=true"
import script from "./MyChild.vue?vue&type=script&lang=js"
export * from "./MyChild.vue?vue&type=script&lang=js"
import style0 from "./MyChild.vue?vue&type=style&index=0&id=5b58c94a&prod&scoped=true&lang=css"
import style1 from "./MyChild.vue?vue&type=style&index=1&id=5b58c94a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58c94a",
  null
  
)

export default component.exports